import React, { useEffect } from 'react';
import { FAQ } from '../components/home/FAQ';
export function FAQPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen bg-dark-bg" data-id="element-776" data-mp="3gp5xt6ipk407">
      <FAQ data-id="element-777" data-mp="3kslprpju1g6k" />
    </main>;
}